<template>
  <div>
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text">系统清单新增</span>
      </div>
      <div class="h-button-warpper">
        <span class="orgBtn" @click="save('ruleForm')">保存</span>
        <span class="orgBtn" @click="back()">返回</span>
      </div>
    </div>
    <div class="white-bg-radius">
      <div class="rolemanage w-label">
        <div class="card">
          <ul>
            <li v-for="(item, index) in data" :key="index" class="cangbieItem">
              <el-form ref="ruleForm" :model="item" :rules="rules">
                <el-form-item label="系统代号:">
                  <el-input v-model="item.orderNumber"></el-input>
                </el-form-item>
                <el-form-item label="系统名称:">
                  <el-input v-model="item.orderNumber"></el-input>
                </el-form-item>
                <el-form-item label="系统别">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="NKA"></el-radio>
                    <el-radio label="LKA"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="中心别">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="1"></el-radio>
                    <el-radio label="2"></el-radio>
                    <el-radio label="3"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否上线:">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线上销售数据:">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线下销售数据:">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线上仓库数据:">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线下仓库数据:">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线上统仓订单数据">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线上门店订单数据:">
                  <el-radio-group v-model="item.orderNumber">
                    <el-radio label="Y"></el-radio>
                    <el-radio label="N"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </li>
          </ul>
          <div class="add">
            <el-button type="primary" @click.stop="addNew">新增</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonMixin from "@/mixins/common.js";
import { methodPost, methodGet } from "../../api/request.js";
export default {
  name: "shopBaseInfo",
  components: { methodPost, methodGet, commonMixin },
  data() {
    return {
      branchValue: 1,
      data: [
        {
          orderNumber: 1,
          cangBie: "食品仓",
          InventoryLocation: "河北省",
          startTime: ["2018.03.23", "2019.09.22s"]
        },
        {
          orderNumber: 1,
          cangBie: "食品仓",
          InventoryLocation: "河北省",
          startTime: ["2018.03.23", "2019.09.22s"]
        }
      ],
      branchOffice: [
        {
          value: 1,
          label: "公司1"
        },
        {
          value: 2,

          label: "公司2"
        }
      ],
      rules: {
        branchOffice: [{ required: true, message: "此项为必填项" }]
      }
    };
  },
  mixins: [commonMixin],
  created() {
    this.init();
  },
  methods: {
    uploadImage(file) {
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      this.loading = true;
      methodPost(this.action, param).then(res => {
        if (res.code === 0) {
          this.handleAvatarSuccess(res, file);
        } else {
          this.uploadError(res.msg, file);
        }
      });
    },
    uploadError(err, file) {
      this.loading = true;
      this.$message.error(file + "上传失败" + err);
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        this.headImg = res.data.url;
      } else {
        this.$message.error(res.message || "上传图片失败");
      }
    },
    beforeAvatarUpload(file) {
      this.loading = true;
      const isJPG =
        file.type === "image/png/jpeg" || "image/jpg" || "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG、png 格式!");
      } else {
        this.file = file;
        this.uploadImage(file);
      }

      return false;
    },
    save(ruleForm) {
      const params = {
        id: this.id,
        storeName: this.ruleForm.storeName,
        storeExplain: this.ruleForm.storeExplain,
        shopLogo: this.headImg
      };
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          methodPost("/customer/user/modifyCustomerStoreInfo", params)
            .then(res => {
              if (res.code === 0) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                const path =
                  "/config/%2Ftemplate%2Fmodule%2Fstore%2Fstore_list.json";
                this.goBack(path);
                this.delMyself({ path: this.$route.fullPath });
                this.$nextTick(() => {
                  this.$bus.$emit("refresh-grid");
                });
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(errData => {
              this.$message.error("error 出错了");
            });
        } else {
          this.$message.error("店铺名称或商城简述格式有误");
          return false;
        }
      });
    },
    init() {
      methodGet("/customer/user/getCustomerUserById/" + this.id)
        .then(res => {
          if (res.code === 0) {
            const _data = res.data;
            this.ruleForm.storeName = _data.storeName;
            this.ruleForm.storeExplain = _data.storeExplain;
            this.headImg = _data.shopLogo;
            console.log(typeof this.headImg);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(errData => {
          this.$message.error("error 出错了");
        });
    },
    back() {
      const path = "/config/%2Ftemplate%2Fmodule%2Fstore%2Fstore_list.json";
      this.goBack(path);
    },
    addNew() {}
  }
};
</script>
<style type="text/scss" lang="scss" scoped>
.rolemanage {
  display: flex;
  padding: 10px;
  .card {
    flex: 1;
    min-width: 1000px;
    display: inline-block;
    .cangbieItem {
      padding: 10px;
      .el-form {
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .el-form-item {
          display: flex;
          text-align: left;
          .el-form-item__label {
            width: 180px;
            text-align: left;
            padding-right: 5px;
          }
          .el-input,
          .el-textarea {
            display: inline-block;
          }
        }
      }
    }
    .upload-pr {
      position: relative;
    }
    .upload-tip {
      position: absolute;
      bottom: 20px;
      left: 320px;
      font-size: 12px;
      color: #999;
    }
    .wx-img {
      width: 85px;
      height: 85px;
      overflow: hidden;
      background: #ccc;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 85px;
  height: 85px;
  line-height: 85px;
  text-align: center;
}
.avatar {
  width: 85px;
  height: 85px;
  display: block;
}
.add {
  margin: 20px 0 0 130px;
}
</style>
<style>
.avatar-uploader .el-upload:hover {
  border-color: #dca864;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader.noBorder .el-upload {
  border: 1px dashed #fff;
}
.timepicker .el-form-item__content {
  width: 240px;
}
.timepicker .el-input--suffix .el-input__inner {
  padding-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/systemList/index.vue